declare const gtag: (command: string, commandParameters?: any, additionalConfigInfo?: any) => any;

export class GTag {
    static event(action: string, detail: EventDetail) {
        let windowObject: any = window;
        if (windowObject.gtag && navigator.onLine) {
            gtag("event", action, detail);
        }
    }

    static purchase(price: number, planName: "Sermon Maker - Monthly" | "Sermon Maker - Annual") {
        let windowObject: any = window;
        if (windowObject.gtag) {
            let item = {
                "id": "plan_EwKerZhWAamWP2",
                "name": planName,
                "brand": "Sermon Maker",
                "category": "Sermon Maker Subscription",
                "quantity": "1",
                "price": price.toString(),
            };
            let transaction = {
                "transaction_id": new Date().getTime().toString(),
                "affiliation": "Sermon Maker",
                "value": price.toString(),
                "currency": "USD",
                "shipping": "0",
                "tax": "0",
                "items": [ item ]
            };

            gtag('event', 'purchase', transaction);

            // make publicly visible by copying event to window so marketing can use GTM
            windowObject.gaItem = item;
            windowObject.gaTransaction = transaction;
        }
    }

    static setUserId(userId: string, trackingId: string) {
        gtag('config', trackingId, {
            'user_id': userId
        });
    }
}

export interface EventDetail {
    event_category: string;
    event_label?: string;
    value?: number;
}
